<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form" >
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" placeholder="关键词"></el-input>
                </el-form-item>
                <el-form-item label="类型" >
                    <el-select v-model="form.type"   placeholder="全部" style="width: 120px">
                        <el-option label="平均分" :value="1"></el-option>
                        <el-option label="作品数" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="状态" >
                    <el-select v-model="form.useType"   placeholder="全部" style="width: 120px">
                        <el-option label="小于" :value="1"></el-option>
                        <el-option label="大于" :value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="分数/数量">
                    <el-input-number v-model="form.num"  :min="0"  label="" ></el-input-number>
                </el-form-item>
            </el-form>
        </div>
        <div class="panel_body">
            <el-table
                :data="tableData"
                stripe
                style="width: 100%">
                <el-table-column
                    min-width="150"
                    prop="name"
                    label="用户名">
                </el-table-column>
                <el-table-column
                    min-width="150"
                    prop="sn"
                    label="账号">
                </el-table-column>
                <el-table-column
                    min-width="180"
                    label="平均分" v-if="form.type == 1">
                    <template slot-scope="scope">
                        <div class="fx-col fx-center">
                            <span>{{scope.row.averageScore}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    min-width="180"
                    label="作品数" v-if="form.type == 2">
                    <template slot-scope="scope">
                        <div class="fx-col fx-center">
                            <span>{{scope.row.workCount}}</span>
                        </div>
                    </template>
                </el-table-column>

            </el-table>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: {
                    type:1,
                    useType: 2,
                    num:0,
                },

                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
                tableData: [],
            }

        },

        watch: {
            "form": {
                handler: function (newValue) {
                    if(this.form.num == null){
                        this.form.num = 0;
                    }
                    this.pager.currentPage = 1;
                    this.loadData();
                },
                deep: true
            },

        },
        methods: {
            loadData() {
                this.$ajaxPost("/user/listWorkStatistics", {
                    form: this.form,
                    pager: {...this.pager, dataTotal: 0}
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    this.tableData = data.result;
                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadData();
            },
        },
        created() {
            this.loadData();
        }

    }
</script>
